// 画像の高さ調整
function adjustImageHeight() {
  const screenHeight = window.innerHeight; // 画面の高さを取得
  const screenWidth = window.innerWidth; // 画面の幅を取得
  const imgElement = document.querySelector(".u-img-cover");

  if (screenWidth >= 1200) {
    imgElement.style.height = `${screenHeight}px`; // 画面の高さに合わせる
    imgElement.style.width = "auto"; // 横幅は自動
  } else {
    imgElement.style.height = "auto"; // 1200px以下はCSSに委ねる
    imgElement.style.width = "100vw"; // 横幅いっぱい
  }
}

// 初回適用
adjustImageHeight();

// 画面サイズ変更時に再適用
window.addEventListener("resize", adjustImageHeight);

document.addEventListener("DOMContentLoaded", function () {

  // Video Configurations
  const heroSection = document.querySelector(".section-hero");

  let v = heroSection.querySelector("video");
  let playButton = heroSection.querySelector(".video-control .play-switch");

  let is_playing = false;
  playButton.addEventListener('click', () => {
    if (!is_playing) {
      v.play();
      playButton.classList.add('fadeout');
      playButton.classList.remove('fadein');
    } else {
      v.pause();
      is_playing = false;
    }
  });
  v.addEventListener('ended', function() {
    playButton.classList.remove('fadeout');
    playButton.classList.add('fadein');
    // playButton.style.display = "flex";
  }, false);


  // scroll text effect
  gsap.registerPlugin(ScrollTrigger);

  // 各 .scroll_text-wrapper のアニメーション設定
  const targetElement_2 = document.querySelectorAll('.scroll_text-wrapper');
  targetElement_2.forEach((element, index) => {
    gsap.set(element, { opacity: 0, y: 100 });
    let tl;
  if (index === 0) {
      tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          toggleActions: 'play reverse play reverse',
          id: `id_${index}`,
          start: `top+=${index * 1}%`,
          end: `+=100%`,
          invalidateOnRefresh: true,
          onEnter: () => {
            targetElement_2.forEach((item) => {
              item.classList.remove('active');
            });
            targetElement_2[index].classList.add('active');
            gsap.to(element, { opacity: 1, y: 0 });
          },
          onLeave: () => {
            gsap.to(element, { opacity: 0, y: -100 });
          },
          onEnterBack: () => {
            targetElement_2.forEach((item) => {
              item.classList.remove('active');
            });
            targetElement_2[index].classList.add('active');
            gsap.to(element, { opacity: 1, y: 0 });
          },
          onLeaveBack: () => {
            gsap.to(element, { opacity: 0, y: 100, duration: 0.3});
          }
        }
      });
    } else 
  
  {
      tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          toggleActions: 'play reverse play reverse',
          id: `id_${index}`,
          start: `top+=${index * 1}%`,
          end: `+=5%`,
          invalidateOnRefresh: true,
          onEnter: () => {
            targetElement_2.forEach((item) => {
              item.classList.remove('active');
            });
            targetElement_2[index].classList.add('active');
            gsap.to(element, { opacity: 1, y: 0 });
          },
          onLeave: () => {
            gsap.to(element, { opacity: 0, y: -100 });
          },
          onEnterBack: () => {
            targetElement_2.forEach((item) => {
              item.classList.remove('active');
            });
            targetElement_2[index].classList.add('active');
            gsap.to(element, { opacity: 1, y: 0 });
          },
          onLeaveBack: () => {
            gsap.to(element, { opacity: 0, y: 100 });
          }
        }
      });
    }
    // ※ここで個別の tl.to() は不要
  });









  // section-highlight および section-scroll-mouse の背景位置調整
  // const sectionHighlight = document.querySelector(".section-highlight");
  // const sectionScrollMouse = document.querySelector(".section-scroll-mouse");
  // const sectionHighlightBackground = sectionHighlight.querySelector(".comn-scroll_bg");
  // const sectionScrollMouseBackground = sectionScrollMouse.querySelector(".product-sticky");

  // if (!sectionHighlight) return;

  // window.addEventListener("scroll", () => {
  //   const rectHighlight = sectionHighlight.getBoundingClientRect();
  //   const rectScrollMouse = sectionScrollMouse.getBoundingClientRect();
  //   const windowHeight = window.innerHeight;

  //   if ((rectHighlight.bottom * 0.2) <= windowHeight) {
  //     sectionHighlightBackground.style.position = "fixed";
  //     sectionHighlightBackground.style.zIndex = "0";
  //     sectionHighlightBackground.style.width = "100%";
  //   } else {
  //     sectionHighlightBackground.style.position = "sticky";
  //     sectionHighlightBackground.style.zIndex = "2";
  //     sectionHighlightBackground.style.width = "auto";
  //   }

  //   if ((rectScrollMouse.bottom * 0.1) <= windowHeight) {
  //     sectionScrollMouseBackground.style.position = "fixed";
  //     sectionScrollMouseBackground.style.zIndex = "0";
  //     sectionScrollMouseBackground.style.width = "100%";
  //   } else {
  //     sectionScrollMouseBackground.style.position = "sticky";
  //     sectionScrollMouseBackground.style.zIndex = "2";
  //     sectionScrollMouseBackground.style.width = "auto";
  //   }
  // });

  // Accordion
  const ariaExpands = document.querySelectorAll('div[aria-expanded]');
  if(ariaExpands != null){
    ariaExpands.forEach((ariaExpand, index) => {
      ariaExpand.addEventListener('click', function(e) {
        let childHeight = this.nextElementSibling.children[0].offsetHeight
        // childHeight = childHeight + 45;
        if (ariaExpand.ariaExpanded === "true") {
          ariaExpand.ariaExpanded = "false"
          this.parentNode.children[1].style.maxHeight = '0px';
          this.parentNode.children[1].style.overflow = "hidden";
        } else {
          ariaExpand.ariaExpanded = "true"
          this.parentNode.children[1].style.maxHeight = childHeight + 'px';
          console.log(this.parentNode.children[1]);
          setTimeout(()=>{
            this.parentNode.children[1].style.overflow = "visible";
          }, 400);
        }
        this.parentNode.classList.toggle('is-active');
      })
    })
  }
});

// product scroll effect
function scrollEffect(canvasID, frameCount, scrollImageUrl, imageExtension, effectContainer, textID) {
  document.addEventListener("DOMContentLoaded", function () {
    const html = document.documentElement;
    const canvas = document.querySelector(canvasID);
    const context = canvas.getContext("2d");
    const scrollText = document.querySelector(textID);

    const currentFrame = index =>
      `${scrollImageUrl}${index.toString().padStart(4, '0')}.${imageExtension}?20250318`;

    let images = [];
    let loadedImages = 0;
    let targetFrameIndex = 1;
    let lerpFrameIndex = 1;

    // 画像の事前ロード
    const preloadImages = () => {
      for (let i = 1; i <= frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        img.onload = () => {
          loadedImages++;
        };
        images.push(img);
      }
    };

    // 画像描画
    const drawImageRotated = (image) => {
      const aspectRatio = image.width / image.height;
      const canvasAspectRatio = canvas.width / canvas.height;

      let renderWidth, renderHeight;
      if (aspectRatio > canvasAspectRatio) {
        renderWidth = canvas.height * aspectRatio;
        renderHeight = canvas.height;
      } else {
        renderWidth = canvas.width;
        renderHeight = canvas.width / aspectRatio;
      }

      const scaleFactor = 0.5;
      renderWidth *= scaleFactor;
      renderHeight *= scaleFactor;

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.save();

      const angle = 32.03 * Math.PI / 180;
      context.translate(canvas.width / 2, canvas.height / 2);
      context.rotate(angle);
      context.drawImage(
        image,
        -renderWidth / 2,
        -renderHeight / 2,
        renderWidth,
        renderHeight
      );

      context.restore();
    };

    // スムーズな画像切り替え
    const updateImageSmoothly = () => {
      if (Math.abs(lerpFrameIndex - targetFrameIndex) > 0.1) {
        lerpFrameIndex += (targetFrameIndex - lerpFrameIndex) * 0.1;
        requestAnimationFrame(updateImageSmoothly);
      }

      const currentImageIndex = Math.round(lerpFrameIndex);
      if (images[currentImageIndex]) {
        drawImageRotated(images[currentImageIndex]);
      }
    };

    window.addEventListener('scroll', () => {
      const scrollTop = html.scrollTop;
      const container = document.querySelector(effectContainer);
      const containerPosition = container.offsetTop;
      let divide_dotArray = container.querySelectorAll(".divide_dot");
      let divide_lineArray = container.querySelectorAll(".divide_line");

      let divide_dotFirstArray = container.querySelectorAll(".feature-text.first-wrap .divide_dot");
      let divide_lineFirstArray = container.querySelectorAll(".feature-text.first-wrap .divide_line");
      let divide_dotSecondArray = container.querySelectorAll(".feature-text.second-wrap .divide_dot");
      let divide_lineSecondArray = container.querySelectorAll(".feature-text.second-wrap .divide_line");
      let featureTextFirstTitleArray = container.querySelectorAll(".feature-text.first-wrap h2");
      let featureTextFirstParagraphArray = container.querySelectorAll(".feature-text.first-wrap .feature-text-desc p");
      let featureTextSecondTitleArray = container.querySelectorAll(".feature-text.second-wrap h2");
      let featureTextSecondParagraphArray = container.querySelectorAll(".feature-text.second-wrap .feature-text-desc p");

      if (scrollTop >= containerPosition) {
        const ReallscrollTop = scrollTop - containerPosition;
        const maxScrollTop = container.scrollHeight - window.innerHeight;

        const scrollFraction = ReallscrollTop / maxScrollTop;
        targetFrameIndex = Math.min(frameCount - 1, Math.ceil(scrollFraction * frameCount));
        const scaleX = Math.max(0, Math.min(1, (scrollFraction - 0.32) * (1 / 0.1)));

        if (loadedImages === frameCount) {
          updateImageSmoothly();
        }

        // メインのテキストをスクロールに合わせて流す
        gsap.to(scrollText, {
          x: (-window.innerWidth * scrollFraction) * 3,
          duration: 0.3,
          ease: "power2.out"
        });

        let opacityValue;
        let scaleValue;
        divide_dotArray.forEach((divide_dot, i) => {
          if (scrollFraction > 0.3) {
            opacityValue = 1;
            scaleValue = 1;
          } else if (scrollFraction <= 0.3) {
            opacityValue = 0;
            scaleValue = 0.1;
          }
          gsap.to(divide_dot, { opacity: opacityValue, scaleX: scaleValue, scaleY: scaleValue, scrub: true, duration: 0.3 });
        });

        //最初は、線をfirst,secondどちらも伸ばす
        divide_lineArray.forEach(divideLine => {
          gsap.to(divideLine, {
            scaleX: scaleX,
            duration: 0.1,
            ease: "none"
          });
        });

        //最初は、fisrtは見せて、secondは見せない(文字が2行になった場合の対策)
        divide_lineFirstArray.forEach((divide_lineFirst) => {
          let yValue;
          console.log("scrollFraction");
          console.log(scrollFraction);
          console.log("scrollFraction");
          if (scrollFraction <= 0.44) {
            yValue = "0%";
          } else if (scrollFraction > 0.44 && scrollFraction <= 0.67) {
            yValue = "0%";
          } else {
            yValue = "500%";
          }

          gsap.to(divide_lineFirst, {
            y: yValue,
            x: 1,
            duration: 0,
            overwrite: "auto"
          });
        });

        divide_dotFirstArray.forEach((divide_dotFirst) => {
          let yValue;

          if (scrollFraction <= 0.44) {
            yValue = "0%";
          } else if (scrollFraction > 0.44 && scrollFraction <= 0.67) {
            yValue = "0%";
          } else {
            yValue = "500%";
          }

          gsap.to(divide_dotFirst, {
            y: yValue,
            duration: 0,
            overwrite: "auto",
          });
        });

        //secondが出現した際、firstを見せない(文字が2行になった場合の対策)
        divide_lineSecondArray.forEach((divide_lineSecond, i) => {
          gsap.to(divide_lineSecond, { y: (scrollFraction > 0.71) ? "0%" : "500%", scrub: true, duration: 0.1 });
        });

        divide_dotSecondArray.forEach((divide_dotSecond, i) => {
          gsap.to(divide_dotSecond, { y: (scrollFraction > 0.71) ? "0%" : "500%", scrub: true, duration: 0.1 });
        });




        featureTextFirstTitleArray.forEach((featureTextFirstTitle) => {
          let yValue;

          if (scrollFraction <= 0.4) {
            yValue = "100%";
          } else if (scrollFraction > 0.44 && scrollFraction <= 0.67) {
            yValue = "0%";
          } else {
            yValue = "100%";
          }

          gsap.to(featureTextFirstTitle, {
            y: yValue,
            duration: 0.6,
            overwrite: "auto",
            ease: "power2.out"
          });
        });

        featureTextFirstParagraphArray.forEach((featureTextFirstParagraph) => {
          let yValue;

          if (scrollFraction <= 0.441) {
            yValue = "100%";
          } else if (scrollFraction > 0.441 && scrollFraction <= 0.67) {
            yValue = "0%";
          } else {
            yValue = "1000%";
          }

          gsap.to(featureTextFirstParagraph, {
            y: yValue,
            duration: 0.6,
            overwrite: "auto",
            ease: "power2.out"
          });
        });

        featureTextSecondTitleArray.forEach((featureTextSecondTitle, i) => {
          gsap.to(featureTextSecondTitle, { y: (scrollFraction > 0.71) ? "0%" : "100%", scrub: true, duration: 0.6 });
        });

        featureTextSecondParagraphArray.forEach((featureTextSecondParagraph, i) => {
          gsap.to(featureTextSecondParagraph, { y: (scrollFraction > 0.711) ? "0%" : "100%", scrub: true, duration: 0.6 });
        });
      }
    });

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    preloadImages();
  }, false);
}

scrollEffect(
    '#tenz-product-hero',
  121,
  'https://cdn.shopify.com/s/files/1/0455/0914/8840/files/Tenz_Black_Front_Rotation-',
  'webp',
  '.product-scroll',
  '#scroll-text'
);